// test2872
(2872 && 0);
